import React, { useRef, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Upload, CheckCircle2, Loader2 } from 'lucide-react';

const SingleFileUpload = ({ onUpload, loading, uploaded, count, label }) => {
  const fileInputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleFileInput = (e) => {
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
      e.target.value = '';
    }
  };

  const handleFile = async (file) => {
    const validExtensions = ['.xlsx', '.xls', '.csv'];
    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
    if (!validExtensions.includes(fileExtension)) {
      alert('Por favor, selecione um arquivo Excel (.xlsx, .xls) ou CSV (.csv)');
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      alert('O arquivo é muito grande. Tamanho máximo: 10MB');
      return;
    }
    try {
      await onUpload(file);
    } catch (error) {
      console.error('Erro ao fazer upload:', error);
    }
  };

  return (
    <div
      className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors ${
        dragActive
          ? 'border-green-400 bg-green-400/10'
          : uploaded
          ? 'border-green-500/50 bg-green-500/5'
          : 'border-white/20 hover:border-white/40'
      }`}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDrop={handleDrop}
      onDragOver={handleDrag}
    >
      <input
        ref={fileInputRef}
        type="file"
        accept=".xlsx,.xls,.csv"
        onChange={handleFileInput}
        className="hidden"
      />

      {uploaded ? (
        <div className="space-y-2">
          <CheckCircle2 className="w-12 h-12 text-green-400 mx-auto" />
          <p className="text-green-400 font-semibold">Relatório carregado!</p>
          <p className="text-white/70 text-sm">
            {count} {count === 1 ? 'venda' : 'vendas'} encontradas
          </p>
          <Button
            variant="outline"
            size="sm"
            onClick={() => fileInputRef.current?.click()}
            className="mt-4 border-white/20 text-white hover:bg-white/10"
          >
            <Upload className="w-4 h-4 mr-2" />
            Trocar Arquivo
          </Button>
        </div>
      ) : loading ? (
        <div className="space-y-2">
          <Loader2 className="w-12 h-12 text-blue-400 mx-auto animate-spin" />
          <p className="text-blue-400 font-semibold">Processando arquivo...</p>
          <p className="text-white/70 text-sm">Aguarde um momento</p>
        </div>
      ) : (
        <div className="space-y-4">
          <Upload className="w-12 h-12 text-white/40 mx-auto" />
          <div>
            <p className="text-white font-semibold mb-2">
              {label || 'Arraste e solte o arquivo aqui'}
            </p>
            <p className="text-white/60 text-sm mb-4">ou</p>
            <Button
              onClick={() => fileInputRef.current?.click()}
              className="bg-gradient-to-r from-blue-600 to-sky-600 hover:from-blue-700 hover:to-sky-700"
            >
              <Upload className="w-4 h-4 mr-2" />
              Selecionar Arquivo
            </Button>
          </div>
          <p className="text-white/50 text-xs">
            Formatos aceitos: .xlsx, .xls, .csv (máx. 10MB)
          </p>
        </div>
      )}
    </div>
  );
};

export default SingleFileUpload;
